import { api } from '@viilutalous/common';

export const employeesAPI = {
  getAll: (tenantId, params) => api.get(`/${tenantId}/employees`, { params }),
  getOne: (tenantId, id) => api.get(`/${tenantId}/employees/${id}`),
  create: (tenantId, data) => api.post(`/${tenantId}/employees`, data),
  update: (tenantId, id, data) => api.put(`/${tenantId}/employees/${id}`, data),
  delete: (tenantId, id) => api.delete(`/${tenantId}/employees/${id}`),
};

export const departmentsAPI = {
  getAll: (tenantId, params) => api.get(`/${tenantId}/departments`, { params }),
  getOne: (tenantId, id) => api.get(`/${tenantId}/departments/${id}`),
  create: (tenantId, data) => api.post(`/${tenantId}/departments`, data),
  update: (tenantId, id, data) => api.put(`/${tenantId}/departments/${id}`, data),
  delete: (tenantId, id) => api.delete(`/${tenantId}/departments/${id}`),
};

export const usersAPI = {
  getByTenant: (tenantId) => api.get(`/${tenantId}/features/users`),
};
